import { dateRangeTexts as sharedDateRange } from '@shared/ui/DateRange/texts';
import { tableTexts as sharedTable } from '@shared/ui/Table/texts';
import common from './commonText.js';
import component from './component/texts.js';
import feature from './feature/texts.js';
import presentation from './presentation/text.js';
import view from './view/text.js';

const shared = {
  ui: {
    daterange: sharedDateRange,
    table: sharedTable,
  },
};

export default {
  ...view,
  common,
  component,
  feature,
  presentation,
  shared,
};
